<template>
  <div class="block">
    <!-- table actions -->
    <div class="px-5 py-5">
      <!-- top search bar -->
      <div class="d-flex">
        <div class="form-input-group flex-grow-1 mr-5">
          <div class="prepend-icon" style="top: 45%;">
            <v-icon>search</v-icon>
          </div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <button class="btn btn-primary w-88px" @click="getShareholderFaqs">搜尋</button>
      </div>
    </div>

    <!-- table -->
    <div class="table">
      <div class="table-head">
        <!-- column head -->
        <div class="form-item d-flex px-5 h-60px align-center">
          <h5 class="col-icon"></h5>
          <h5 class="col-number">No.</h5>
          <h5 class="col-question">Question</h5>
          <h5 class="col-icon ml-auto"></h5>
          <h5 class="col-icon"></h5>
          <h5 class="col-icon">編輯</h5>
          <h5 class="col-icon">刪除</h5>
        </div>
      </div>
      <div class="table-body">
        <TableCollapse v-for="(item, i) in shareholderFaqs" :key="item.id">
          <!-- row 1 -->
          <template v-slot:head="slotProps">
            <div class="form-item d-flex h-60px align-center">
              <div class="h5 col-icon">
                <v-icon color="ink-01-emphasis" v-if="!slotProps.isBodyShow"
                  >unfold_more</v-icon
                >
                <v-icon color="ink-01-emphasis" v-if="slotProps.isBodyShow"
                  >unfold_less</v-icon
                >
              </div>
              <div class="h5 col-number">Q{{ i + 1 }}</div>
              <div class="h5 col-question">
                {{
                  item.question.length >= 38
                    ? `${item.question.slice(0, 34)}…`
                    : item.question
                }}
              </div>
              <div class="col-icon ml-auto">
                <button class="btn square" @click.stop="upItem(item, i)">
                  <v-icon>arrow_upward</v-icon>
                </button>
              </div>
              <div class="col-icon">
                <button class="btn square" @click.stop="downItem(item, i)">
                  <v-icon>arrow_downward</v-icon>
                </button>
              </div>
              <div class="col-icon">
                <button class="btn square" @click.stop="editItem(item.id)">
                  <v-icon>edit</v-icon>
                </button>
              </div>
              <div class="col-icon">
                <deleteDialog
                  @confirm-delete="deleteItem(item.id)"
                ></deleteDialog>
              </div>
            </div>
          </template>
          <!-- row 2 -->
          <template v-slot:body>
            <div class="form-item py-5" style="font-size: 14px;">
              <!-- Question -->
              <div class="d-flex pa-10px gray-100">
                <h5 class="w-120px mr-10px">Question</h5>
                <div class="flex-grow-1 flex-basis-0">
                  {{ item.question }}
                </div>
              </div>
              <!-- Answer -->
              <div class="d-flex pa-10px">
                <h5 class="w-120px mr-10px">Answer</h5>
                <div class="flex-grow-1 flex-basis-0" v-html="item.ans"></div>
              </div>
            </div>
          </template>
        </TableCollapse>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableCollapse from '@/components/TableCollapse.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    TableCollapse,
    deleteDialog,
  },
  computed: {
    ...mapState('shareholderFaq', ['shareholderFaqs', 'filter']),
  },
  methods: {
    ...mapActions('shareholderFaq', {
      getShareholderFaqs: 'find',
      destroyShareholderFaq: 'destroy',
      saveOrder: 'saveOrder',
      clear: 'clear',
    }),
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        // this.shareholderFaqs.splice(i, 1);
        // this.shareholderFaqs.push(item);
        return;
      }
      // item become previous index
      this.shareholderFaqs.splice(i, 1);
      this.shareholderFaqs.splice(i - 1, 0, item);
      this.handleOrder();
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.shareholderFaqs.length - 1) {
        // this.shareholderFaqs.splice(i, 1);
        // this.shareholderFaqs.unshift(item);
        return;
      }
      // item become next index
      this.shareholderFaqs.splice(i, 1);
      this.shareholderFaqs.splice(i + 1, 0, item);
      this.handleOrder();
    },
    editItem(id) {
      this.$router.push({
        name: 'InvestorFAQEdit',
        params: { id },
      });
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyShareholderFaq(id).then(() => {
        this.getShareholderFaqs();
      });
    },
    async handleOrder() {
      await this.saveOrder({
        shareholder_faqs: this.shareholderFaqs,
      }).then(() => {
        this.clear();
        this.getShareholderFaqs();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-number {
    width: 90px;
    margin-right: 10px;
  }
  .col-question {
    width: 500px;
  }
}
</style>
